var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialogVisible
    ? _c(
        "el-dialog",
        {
          attrs: {
            width: "800px",
            title: _vm.title,
            visible: _vm.dialogVisible,
            "before-close": _vm.dialogClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("BjPage", {
            ref: "BjPage",
            attrs: {
              height: "500px",
              "col-span": _vm.colSpan,
              "get-action": _vm.queryApi,
              "query-params": _vm.queryParams,
              serial: _vm.serial,
              selection: _vm.selection,
            },
            on: { handleSelectionChange: _vm.handleSelectionChange },
            scopedSlots: _vm._u(
              [
                {
                  key: "baseForm",
                  fn: function () {
                    return [_vm._t("baseForm")]
                  },
                  proxy: true,
                },
                {
                  key: "tableColumn",
                  fn: function () {
                    return [
                      _vm._l(_vm.dropCols, function (col, index) {
                        return [
                          col.prop !== "bjTableAction"
                            ? _c("el-table-column", {
                                key:
                                  "col_" +
                                  index +
                                  "_" +
                                  col.prop +
                                  "_" +
                                  (col.width || "auto"),
                                attrs: {
                                  prop: col.prop,
                                  label: col.label,
                                  width: col.width || "auto",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          false
                                            ? void 0
                                            : col.prop == "staffDepartment"
                                            ? [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        _vm.staffDeptList.bjGet(
                                                          scope.row[col.prop]
                                                        )
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            : col.prop == "staffRole"
                                            ? [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        _vm.staffRoleList.bjGet(
                                                          scope.row[col.prop]
                                                        )
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("timeFilters")(
                                                      scope.row[col.prop],
                                                      scope.row[col.prop]
                                                    )
                                                  )
                                                ),
                                              ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : _vm._e(),
                        ]
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.dialogClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.dialogConfirm },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }